import { render, staticRenderFns } from "./ChangeInfo.vue?vue&type=template&id=30055c50&scoped=true&"
import script from "./ChangeInfo.vue?vue&type=script&lang=js&"
export * from "./ChangeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30055c50",
  null
  
)

export default component.exports